import { render, staticRenderFns } from "./MerchantCustomer.vue?vue&type=template&id=019fd803&"
import script from "./MerchantCustomer.vue?vue&type=script&lang=js&"
export * from "./MerchantCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports